<script>
    import { isOfferVisible } from "./stores";
    $: display = $isOfferVisible ? "block" : "none";
</script>

<div class="offer" id="OFFER" style="display:{display}">
    <div class="textDiv" id="OFFER_TEXT">
        <center>
            <b>ШАРТНОМАИ ПЕШНИҲОДИ ОММАВӢ</b>
            <p>бо иштирокчии лотереяи электронии миллии Ҷумҳурии Тоҷикистон</p>
        </center>
        <p style="text-indent: 2em;">
            Бо ризояти Шартномаи мазкури пешниҳоди оммавӣ, тавассути пахш
            намудани тугмачаи марбута дар экрани терминали лотерея, инчунин
            интихоб ва пардохт намудани комбинатсияи дилхоҳи лотерея, ки аз
            ҷониби Ташкилкунандаи лотереяҳои электронӣ гузаронида мешаванд,
            иштирокчии Лотереяҳои электронии миллии Ҷумҳурии Тоҷикистон, ки аз
            тарафи Ҷамъияти саҳомии пӯшидаи ҶДММ «БОЗИ» мутобиқи Қарори
            Ҳукумати Ҷумҳурии Тоҷикистон таҳти №274 аз 03 июли соли 2002 "Дар
            бораи тартиби гузаронидани лотерея дар Ҷумҳурии Тоҷикистон"
            гузаронида мешаванд, бастани Шартномаи мазкурро бо Ташкилкунандаи
            лотерея тасдиқ мекунад ва инчунин ризояти худро бо мафҳуму истилоҳот
            ва ҳуқуқу ӯҳдадориҳои Ҷонибҳоро, ки дар Шартномаи мазкур ифода
            ёфтаанд тасдиқ мекунад.
        </p>
        <ol>
            <li style="font-weight:bold;">
                Мафҳуму истилоҳот.
                <ol style="font-weight:normal;text-indent: 2em;">
                    <li>
                        Ташкилкунандаи лотереяи электронӣ – Ҷамъияти саҳомии
                        пӯшидаи ҶДММ «БОЗИ»
                        <br />Суроғаи ҳуқуқӣ: шахри Душанбе, нохяи Шохмансур, хиёбони Рудаки 6А;
                        <br />Рақами ИНН: 040057326;
                        <br />Реквизитҳои бонкӣ: К/ҳисоб: 20402972413691;
                        <br />БИК: 350101626.
                    </li>
                    <li>
                        <b>Иштирокчии лотерея</b> – шахси воқеи, ки ба синну соли
                        18 расидааст, аз қобилияти ҳуқуқӣ маҳрум нашудааст, дар васоят
                        ва парасторӣ қарор надорад ва тибқи қонунгузории амалкунандаи
                        Ҷумҳурии Тоҷикистон барои бастани Шартномаи мазкур дорои
                        тамоми ҳуқуқҳоро дорад. Иштирокчии лотерея он фарде эътироф
                        карда мешавад, ки ба талаботҳои нишондодаи банди мазкур мувофиқат
                        мекунад ва дар бораи иштирок дар Лотереяи электронии миллӣ
                        тавассути интихоб намудани комбинатсияи лотерея ва пардохти
                        маблағи лотерея қарор қабул кардааст.
                    </li>
                    <li>
                        <b>Лотереяи электронӣ</b> (лотерея) – лотереяе, ки аз ҷониби
                        Ташкилкунандаи лотерея дар қаламрави Ҷумҳурии Тоҷикистон
                        мутобиқи иҷозатнома барои гузаронидани лотереяи электронӣ,
                        ки аз тарафи мақомоти ваколатдор дода шудааст, гузаронида
                        мешавад. Лотереяи электронӣ – ин лотереяи тиражӣ мебошад,
                        ки дар он ба бозӣ даровардани фонди ҷоизавӣ байни ҳамаи иштирокчиён
                        лотерея дар як вақт баъди паҳн гаштани расидҳои электронии
                        лотерея, аз ҷониби иштирокчиёни лотерея интихоб кардани комбинатсия
                        ва пардохт намудани маблағи лотерея гузаронида мешавад. Гузаронидани
                        чунин лотерея, худ як тиражи алоҳидаро дар бар мегирад, ки
                        барои муайян намудани комбинатсияҳои бурднок равона карда
                        шудааст, ки аз манбаи ягонаи гузаронидани бозии қуръакаширо
                        – сервери тиражӣ ташкилкунандаи лотерея бар меоянд.
                    </li>
                    <li>
                        <b>Терминали иштирокчии лотерея</b> – таҷҳизоти махсусе,
                        ки барои фурӯши расидҳои электронии лотереяҳо ба Иштирокчии
                        лотерея, аз ҷониби Иштирокчӣ муайян намудани комбинатсияи
                        лотерея ва маблағи лотерея нисбат ба тиражи лотерея, ба Иштирокчии
                        лотерея нишон додани натиҷаҳои тиражи лотерея, муайян намудани
                        бурди Иштирокчӣ доир ба тиражи гузаронида.
                    </li>
                    <li>
                        <b>Корти мушаххаскунандаи Иштирокчии лотерея</b> – корти
                        махсуси электроние, ки арзиши вориднамудаи маблағи пулии
                        Иштирокчии лотерея ва инчунин маълумоте, ки ба Маркази коркарди
                        иттилооти лотереяро аз ҷониби Ташкилкунанда ва мушаххас намудани
                        Иштирокчии лотерея, аз он ҷумла маълумот дар бораи маблағҳои
                        лотерея, бурдҳои пардохтшуда ва пардохтнашударо дар бар мегирад.
                    </li>
                    <li>
                        <b>Комбинатсияи лотерея</b> – маҷмӯи рамз ё ададҳое, ки тибқи
                        Шарту қоидаҳои гузаронидани лотерея пешбинӣ шудааст ва ба
                        расиди электронии лотерея ворид карда мешаванд. Миқдори комбинатсияҳои
                        лотерея дар расиди электронии лотерея бо шартҳои гузаронидани
                        лотерея муайян карда мешаванд.
                    </li>
                    <li>
                        <b>Меъёри лотерея (ставка)</b> – нархи як комбинатсияи пардохтшудаи
                        лотерея. Қабули меъёри лотерея ба иштирокчӣ нишон додани
                        расиди электронии лотерея ва ба қайд гирифтани расиди мазкур
                        дар Маркази коркарди иттилооти лотереяи Ташкилкунанда тасдиқ
                        карда мешавад.
                    </li>
                </ol>
            </li>
            <li style="font-weight:bold;">
                Ҳуқуқ ва ӯҳдадориҳои Иштирокчии лотерея.
                <ol style="font-weight:normal;text-indent: 2em;">
                    <li style="font-weight:bold;">
                        Иштирокчии лотерея ӯҳдадор аст:
                        <ul style="font-weight:normal;">
                            <li>
                                пеш аз интихоби комбинатсияи лоторея ва пардохти
                                маблағи меъёри ҳама гуна лотереяҳои электроние,
                                ки Ташкилкунандаи лотереяи электронӣ
                                мегузаронад, бо шартҳои лотереяи миллии
                                электронӣ, инчунин қоидаҳои ин лотерея шинос
                                шавад;
                            </li>
                            <li>
                                дар ҳолати розӣ набудан бо шартҳои Созишномаи
                                мазкур, инчунин дар сурати розӣ набудан ё
                                нафаҳмидани шартҳои лотереяи миллӣ ва дар ҳолати
                                шинос нашудан бо қоидаҳои ин лотерея,
                                комбинатсияҳои лотереяро интихоб накунад ва
                                меъёрҳои лотереяро пардохт накунад;
                            </li>
                            <li>
                                барои иштирок дар лотереяи Электронӣ, Корти
                                мушаххаскунандаи Иштирокчии лотереяро гирад, ки
                                он аз ҷониби Ташкилкунандаи лотерея дар нуқтаҳои
                                фурӯш ва паҳнкунии лотеряҳои Электронӣ бо шарти
                                ворид намудани маблағҳои кофии пулӣ барои меъёри
                                лотерея дода мешаванд;
                            </li>
                            <li>
                                Корти мушаххаскунандаи Иштирокчии лотеряро ба
                                шахсони сеюм надиҳад. Ташкилкунандаи лотерея
                                барои пардохти бурд/бақияи маблағҳои пулие, ки
                                тибқи Корти мушаххаскунандаи Иштирокчии лотерея
                                дар ҳолатҳое, ки корти мазкур ба шахси сеюм дода
                                шудааст ва ё гум карда шудааст, масъул нест;
                            </li>
                            <li>
                                Корти мушаххаскунандаи Иштирокчии лотереяро нест
                                ё нобуд накунад;
                            </li>
                            <li>
                                Корти мушаххаскунандаи Иштирокчии лотерея ба
                                нуқтаи дилхоҳи Ташкилкунандаи лотерея баъд аз
                                истифода бурдан ё гирифтани маблағи пулӣ
                                (гирифтани бурд) тавассути корти мазкур супурда
                                шавад;
                            </li>
                            <li>
                                даъвоҳо, саволҳо ва хоҳишҳо ба Ташкилкунандаи
                                лотерея ба таври хаттӣ тавассути интиқол додани
                                ҳуҷҷат ба нуқтаи паҳнкунии лотереяи
                                Ташкилкунандаи лотерея фиристода шаванд.
                            </li>
                        </ul>
                    </li>
                    <li style="font-weight:bold;">
                        Иштирокчии лотерея ҳуқуқ дорад:
                        <ul style="font-weight:normal;">
                            <li>
                                ҳангоми гирифтани корти Мушаххаскунандаи
                                Иштирокчии лотерея тавассути ворид намудани
                                маълумот ба корти Мушаххаскунанда дар бораи
                                шахсияти Иштирокчӣ аз мушаххасот гузарад, аз
                                ҷумла маълумотҳои зерин: Насаб, ном, номи падар;
                                ҳуҷҷати тасдиқкунандаи шахсият, рақамҳои
                                телефон, суроғаи почтаи электронӣ. Далели
                                мушаххаскунӣ ба Иштирокчӣ иҷозат медиҳад, ки дар
                                бозиҳои махсусе, ки аз ҷониби Ташкилкунандаи
                                лотерея байни Иштирокчиёни ба қайд гирифташудаи
                                лотерея гузаронида мешаванд, иштирок намояд;
                            </li>
                            <li>
                                иттилооти доир ба натиҷаҳои тиражҳои лотереяи
                                миллиро гирад;
                            </li>
                        </ul>
                    </li>
                </ol>
            </li>
            <li style="font-weight:bold;">
                Ҳуқуқ ва вазифаҳои Ташкилкунандаи лотерея.
                <ol style="text-indent: 2em;">
                    <li>
                        Ташкилкунандаи лотерея ӯҳдадор аст:
                        <ul style="font-weight:normal;">
                            <li>
                                бехатарӣ ва паҳн нашудани маълумотро дар бораи
                                Иштирокчиёни лотерея дар ҳаҷми муайяннамудаи
                                қонунгузории амалкунандаи Ҷумҳурии Тоҷикистон
                                таъмин менамояд;
                            </li>
                            <li>
                                ба Иштирокчии лотерея дар мӯҳлат ва тартиби
                                муқаррарнамудаи Шартҳои лотереяи миллии
                                электронии тиражӣ ва замимаҳои он, инчунин
                                қонунгузории амалкунандаи Ҷумҳурии Тоҷикистон
                                бурдҳоро пардохт намояд;
                            </li>
                            <li>
                                даъвоҳо, саволҳо ва хоҳишҳои Иштирокчиёни
                                лотереяро баррасӣ намуда, инчунин тавзеҳоти
                                заруриро дар шакли хаттӣ, шифоҳӣ ё электронӣ дар
                                давоми даҳ рӯзи корӣ аз санаи гирифтан ба
                                Иштирокчии лоторея пешниҳод намояд.
                            </li>
                        </ul>
                    </li>
                    <li>
                        Ташкишкилкунандаи лотерея ҳуқуқ дорад:
                        <ul style="font-weight:normal;">
                            <li>
                                ба Иштирокчии лотерея аз иштирок дар тиражи
                                лотереяи Электронии миллӣ, аз ҷумла, вале бо он
                                маҳдуд накарда, бо катъ кардани корти
                                Мушаххаскунандаи Иштирокчии Лотерея рад кунад;
                            </li>
                            <li>
                                пардохти бурдҳоро ба Иштирокчии лотерея дар
                                давраи ташхиси зарурии расиди лотереяи бурднок,
                                вале на бештар аз як моҳи тақвимӣ боздорад;
                            </li>
                            <li>
                                супоридани бурдҳоро ба Иштирокчии лотерея дар
                                ҳолатҳои зерин рад кунад, агар: Иштирокчии
                                лотерея кӯшиш мекунад, ки бурдро ё маблағи
                                пулиро бо истифода аз корти Мушаххаскунандаи
                                бегона истифода мекунад ва гирад; Иштирокчии
                                лотерея корти Мушаххаскунандаи Иштирокчии
                                лотереяро гум кардааст ё вайрон кардааст;
                                ҳангоми муайян шудани далели гузаронидани
                                маблағи пулии бурдҳо ба корти Мушаххаскунандаи
                                Иштирокчии лотерея дар натиҷаи амалҳои
                                қаллобона, нокомии техникӣ ва амалҳои дигаре, ки
                                ба шартҳои Созишномаи мазкур, Шартҳои Лотереяи
                                миллии электронии тиражӣ ва замимаҳои он
                                мувофиқат намекунанд.
                            </li>
                            <li>
                                ба матни Шартномаи мазкур тағйротҳои яктарафа
                                ворид кунад.
                            </li>
                        </ul>
                    </li>
                </ol>
            </li>
            <li style="font-weight:bold;">
                Масъулияти Тарафҳо.
                <ol style="font-weight:normal;text-indent: 2em;">
                    <li>
                        Иштирокчии лотерея барои тамоми амалҳое, ки бо истифода
                        аз корти Мушаххаскунандаи Иштирокчии лотереяи худ анҷом
                        дода мешаванд, аз ҷумла ҳолатҳои ба шахсони дигар додани
                        ин корт шахсан ҷавобгар аст. Ҳамаи амалҳое, ки бо
                        истифода аз корти Мушаххаскунандаи шахсии Иштирокчии
                        лотерея анҷом дода мешаванд, ҳамчун аз ҷониби худи ӯ
                        иҷрошуда ҳисобида мешаванд.
                    </li>
                    <li>
                        Иштирокчии лотерея барои ҳифзи корти Мушаххаскунанди
                        худи Иштирокчии лотерея шахсан ҷавобгар аст; кортҳои
                        гумшудаи Иштирокчии лотерея барқарор карда намешаванд.
                    </li>
                    <li>
                        Маблағҳои дар корти Мушаххаскунандаи Иштирокчии лотерея
                        гузошта шудаанд, аз ҷумла бурди талабнашуда, ки гум
                        карда шудаанд, аз ҷониби Ташкилкунандаи лотерея ба
                        Иштирокчии лотерея баргардонида намешавад.
                    </li>
                    <li>
                        Маблағҳои пулие, ки аз ҷониби Иштирокчии лотерея дар
                        корти Мушаххаскунанда гузошта шудаанд ва аз ҷониби
                        Иштирокчӣ барои бастани шартҳои лотерея сарф шудаанд
                        баргардонида намешаванд.
                    </li>
                    <li>
                        Иштирокчии лотерея бо бастани Шартномаи мазкур ризояти
                        худро бо тамоми шартҳое, ки аз ҷониби Ташкилкунандаи
                        лотерея дар ҳуҷҷатҳои зерин тасдиқ шудаанд, тасдиқ
                        мекунад:
                        <ul>
                            <li>
                                Шартҳои ба бозӣ даровардани лотереяи тиражии
                                Электронии миллӣ;
                            </li>
                            <li>
                                Замима ба Шартҳои ба бозӣ даровардани лотереяи
                                электронии тиражии миллӣ, ки аз ҷониби Директори
                                ҶДММ «БОЗИ» тасдиқ шудааст. Қоидаҳои
                                гузаронидани лотереяи Электронии тиражӣ “Хоҷа
                                Насриддин”;
                            </li>
                        </ul>
                    </li>
                    <li>
                        Иштирокчии лотерея бо бастани Шартномаи мазкур он
                        далелеро тасдиқ ва қабул мекунад, ки вай аз он огоҳ аст
                        ва инчунин розигии худро ба он ифода мекунад, ки ҳангоми
                        фурӯши расидҳои лотерея он таҷҳизоти электроние истифода
                        бурда мешавад, ки ба омилҳои таъсирбахши фаъолияти
                        мунтазами таъминоти барномавӣ ба монанди нуқсонҳои
                        техникии фаъолияти интернет, нуқсонҳои техникӣ дар
                        таъмини қувваи барқ, нуқсонҳои техникӣ дар фаъолияти
                        ҷузъҳои дохилии терминали лотерея ё таъминоти барномавии
                        лотерея, метавонад ба хатогиҳои эҳтимолии кори таъминоти
                        барномавӣ оварда расонад, ки чунин раванд дар экрани
                        монитор бузургиҳои рақамие инъкос мешаванд, ки (аз ҷумла
                        адаҳои мавҷуднабуда (ба шартҳои лотерея мувофиқат
                        намекунанд) бурдҳое, ки маблағҳои мавҷуднабудаи тавозуни
                        бозингар, аз ҷумла бузургии манфии тавозун ё бурд,
                        бузургиҳое, ки аломатҳои ғайрирақамиро дар бар мегиранд)
                        ки ба шартҳои гузаронидани лотерея мувофиқ нестанд ё ба
                        ҷараёни воқеии бозӣ мувофиқат намекунанд.
                        <br />Мисол: хатогии марбут ба инъикоси рамзи хатогӣ дар
                        равзанаи “Тавозун”, ки дар экран ҳамчун бузургии
                        даҳрақама инъикос мешавад: 42949ХХХ.ХХ, ки дар он «Х»
                        ҳамчун бузургии тартибӣ бо сабаби нуқсони барномавии
                        лотерея вобаста карда шудааст.
                        <br />Дар чунин мавридҳои нуқсонҳои техникӣ, Иштирокчии
                        лотерея ӯҳдадор мешавад, ки аз ташкилкунандаи лотерея ё
                        паҳнкунанда ва фурӯшандаи лотереяи электронӣ ягон намуди
                        маблағҳои ҷуброн талаб накунад, ба истиснои маблағи
                        истифоданабурдаи Иштирокчии лотерея барои гирифтани
                        расидҳои тавозунии лотерея ва/ё бурде, ки мутобиқи
                        шартҳои гузаронидани лотереяи электронӣ аз рӯи ҷамъбасти
                        тиражи бозӣ афтидааст. Иштирокчии бозӣ инчунин розигии
                        худро ба он медиҳад, ки дар ҳолати сар задани нуқсонҳои
                        техникӣ дар фаъолияти таҷҳизоти лотерея ё таъминоти
                        барномавии лотерея, шикоятҳои Иштирокчии лотерея дар
                        муддати панҷ рӯзи корӣ баррасӣ карда мешаванд.
                    </li>
                </ol>
            </li>
        </ol>
    </div>
    <div class="buttonsDiv">
        <button id="CANCEL" class="offerButton">РОЗИ НЕСТАМ</button>
        <button
            id="OK"
            class="offerButton"
            on:click={() => {
                $isOfferVisible = false;
                localStorage.setItem("offer", $isOfferVisible);
            }}>РОЗИЯМ</button
        >
    </div>
</div>

<style>
    .offer {
        display: block;
        position: fixed;
        left: 0;
        top: 0;
        z-index: 1;
        width: 98%;
        height: 98%;
        background-color: #3d6886;
        padding: 1% 1% 1% 1%;
        border: solid 2px #daebf8;
        overflow: auto;
        font-family: "Arial";
        font-size: 14px; /*1.5vmin;*/
        color: #accff9;
        text-align: left;
        border: none;
    }
    .textDiv {
        display: block;
        position: fixed;
        left: 2%;
        top: 2px;
        width: 95%;
        height: 80%;
        background-color: #3d6886;
        padding: 1% 1% 1% 1%;
        overflow: auto;
        font-family: "Arial";
        font-size: 12px;
        color: #accff9;
        text-align: left;
    }
    .buttonsDiv {
        position: relative;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        top: 80%;
        width: 98%;
        height: 18%;
        margin: 0 auto;
    }
    .offerButton {
        position: relative;
        top: 20px;
        width: 200px;
        height: 50px;
        cursor: pointer;
        text-align: center;
        text-align: -webkit-center;
        margin: 0 auto;
    }
    ol {
        counter-reset: item;
    }
    li {
        display: block;
    }
    ol > li:before {
        content: counters(item, ".") " ";
        counter-increment: item;
    }
    ul > li:before {
        content: " - ";
    }
</style>
